module.exports = new __parcel__URL__("generic-error.76ff7c6a.svg").toString();